/**
 * Format numbers to European notation
 * - Thousands separator: . (dot)
 * - Decimal separator: , (comma)
 * 
 * Examples:
 *   1000 → 1.000
 *   1234567.89 → 1.234.567,89
 */

export const formatNumber = (value, decimals = 0) => {
  if (value === null || value === undefined || isNaN(value)) return '0';
  
  const num = Number(value);
  
  // Format with European locale (nl-NL uses dot for thousands, comma for decimals)
  return num.toLocaleString('nl-NL', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
};

export const formatCurrency = (value, decimals = 2) => {
  if (value === null || value === undefined || isNaN(value)) return '€0,00';
  
  const num = Number(value);
  
  return num.toLocaleString('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
};

export const formatPercentage = (value, decimals = 2) => {
  if (value === null || value === undefined || isNaN(value)) return '0%';
  
  const num = Number(value);
  
  return num.toLocaleString('nl-NL', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }) + '%';
};

export const formatCompactNumber = (value) => {
  if (value === null || value === undefined || isNaN(value)) return '0';
  
  const num = Number(value);
  
  // Format large numbers with K, M, B suffix
  if (num >= 1000000000) {
    return (num / 1000000000).toLocaleString('nl-NL', { 
      minimumFractionDigits: 1, 
      maximumFractionDigits: 1 
    }) + 'B';
  } else if (num >= 1000000) {
    return (num / 1000000).toLocaleString('nl-NL', { 
      minimumFractionDigits: 1, 
      maximumFractionDigits: 1 
    }) + 'M';
  } else if (num >= 1000) {
    return (num / 1000).toLocaleString('nl-NL', { 
      minimumFractionDigits: 1, 
      maximumFractionDigits: 1 
    }) + 'K';
  }
  
  return num.toLocaleString('nl-NL', { 
    minimumFractionDigits: 0, 
    maximumFractionDigits: 0 
  });
};






